import { useEffect, type RefObject } from 'react'

export const PUSH_TENANT_QUERY = 'rp-tenant-query'

export const messageSource = (): EventTarget | null => {
  if (!('serviceWorker' in navigator)) return null
  const container: Partial<EventTarget> = navigator.serviceWorker
  return typeof container.addEventListener === 'function' ? (container as EventTarget) : null
}

const isTenantQuery = (data: unknown): boolean =>
  data !== null && typeof data === 'object' && (data as { type?: unknown }).type === PUSH_TENANT_QUERY

export const useAnswerTenantQueries = (shown: RefObject<string | null>): void => {
  useEffect(() => {
    const container = messageSource()
    if (container === null) return
    const answer = (event: MessageEvent) => {
      if (!isTenantQuery(event.data)) return
      event.ports[0]?.postMessage({ tenantId: shown.current })
    }
    container.addEventListener('message', answer as EventListener)
    return () => container.removeEventListener('message', answer as EventListener)
  }, [shown])
}
